import { useMemo } from 'react';

import type { ConsolidatedAnalysis, UploadQueueItem } from '../types';
import { consolidate } from '../utils/consolidate';

/**
 * Memoiza el resultado de `consolidate(items)` para evitar recomputar el merge
 * (categorías + productos + extras + duplicados + sourceMap) en cada render.
 *
 * @param {UploadQueueItem[]} items Lista actual de la cola de subida.
 * @returns {ConsolidatedAnalysis} Análisis consolidado memoizado por referencia de `items`.
 */
export const useConsolidation = (items: UploadQueueItem[]): ConsolidatedAnalysis =>
  useMemo(() => consolidate(items), [items]);
